module.exports = __webpack_public_path__ + "static/media/vei.770cf177.png";